import DistributorContent from '@/containers/SubscriptionFormPageNew/Components/Distributor/DistributorContent'
import DistributorEmpty from '@/containers/SubscriptionFormPageNew/Components/Distributor/DistributorEmpty'
import DistributorLoading from '@/containers/SubscriptionFormPageNew/Components/Distributor/DistributorLoading/DistributorLoading'
import useDistributor from '@/containers/SubscriptionFormPageNew/Components/Distributor/useDistributor'
const Distributor = () => {
  const { noDistributorData, isCityEligibilityLoading, t, hidden } = useDistributor()

  if (hidden) return null

  if (isCityEligibilityLoading) {
    return (
      <DistributorLoading
        title={t('subscriptionForm:distributor.title')}
        text={t('subscriptionForm:distributor.loading_city_eligibility')}
      />
    )
  }

  if (noDistributorData) return <DistributorEmpty />

  return <DistributorContent />
}

export default Distributor
